<template>
  <new-modal-dialog
    visible
    scrollable
    max-width="600"
    persistent
    card-class="px-2"
    :title="$t('settings.user.twofa_dialog_title')"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card
      outlined
      class="pa-4 mt-2 twofa-verify-card"
    >
      <p class="text-subtitle-1 mb-2">
        {{ $t('settings.user.twofa_verify_title') }}
      </p>
      <p class="text-body-2 mb-3 text--secondary">
        {{ $t('settings.user.twofa_verify_subtitle', [
          method === 'sms'
            ? $t('settings.user.twofa_phone')
            : $t('settings.user.twofa_email')
        ]) }}
      </p>
      <v-otp-input
        v-model="code"
        length="4"
        class="mb-0 pb-0"
        autocomplete="none"
        aria-autocomplete="none"
        role="presentation"
        :error-messages="errorMessages"
        name="notASearchField"
        @finish="emit('submit', code)"
        @input="code = (code || '').toUpperCase()"
      />
      <div
        v-if="errorMessages.length"
        class="text-caption red--text mt-n2"
      >
        {{ errorMessages.join(', ') }}
      </div>
    </v-card>

    <template #actions>
      <v-spacer />

      <v-btn
        color="primary"
        class="mr-2"
        :disabled="!code || code.length !== 4"
        @click="emit('submit', code)"
      >
        {{ $t('button.verify') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="emit('cancel')"
      >
        {{ $t('button.cancel') }}
      </v-btn>
    </template>
  </new-modal-dialog>
</template>

<script setup lang="ts">
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import { PropType, ref } from 'vue';

const emit = defineEmits<{(e: 'cancel'): void;
  (e: 'submit', code: string): void;
}>();

const props = defineProps({
  method: { type: String, required: true },
  errorMessages: { type: Array as PropType<string[]>, required: true },
});

const code = ref('');

</script>
